// Vuex holiday module mutations types

export const FILL_CURRENT_LIST = 'FILL_CURRENT_LIST';
export const FILL_LIST = 'FILL_LIST';
